import { Grid, Tooltip, TooltipProps, Typography, withStyles } from '@material-ui/core';
import React, { useMemo } from 'react';
import { MaerskColorPalette } from '../../app.enum';

const HtmlTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: MaerskColorPalette.UltraLightGrey,
		color: theme.palette.text.primary,
		minWidth: 490,
		border: `1px solid ${MaerskColorPalette.BorderGrey}`,
		borderRadius: 2,
	},
}))(Tooltip);

const HtmlTooltipNoMinWidth = withStyles((theme) => ({
	tooltip: {
		backgroundColor: MaerskColorPalette.UltraLightGrey,
		color: theme.palette.text.primary,
		border: `1px solid ${MaerskColorPalette.BorderGrey}`,
		borderRadius: 2,
	},
}))(Tooltip);

const CustomTooltip: React.FC<ICustomTooltipProps> = (props) => {
	const Component = useMemo(() => (props.applyMinWidth ? HtmlTooltip : HtmlTooltipNoMinWidth), [props.applyMinWidth]);

	return (
		<Component
			arrow={true}
			placement='right'
			title={
				<Grid container={true} direction='column'>
					{props.items.map((item, i) => {
						if (item.onRender) {
							return (
								<Grid key={i} item={true} xs={12}>
									{item.onRender()}
								</Grid>
							);
						}

						return (
							<Grid key={item.value + i} item={true} xs={12}>
								{item.header ? (
									<Typography variant='h6' color='inherit' display='inline'>
										<strong>{`${item.header} `}</strong>
									</Typography>
								) : null}
								{item.label ? (
									<Typography variant='body2' color='inherit' display='inline'>
										<strong>{`${item.label}: `}</strong>
									</Typography>
								) : null}

								<Typography variant='body2' color='inherit' display='inline'>
									{' '}
									{item.value}
								</Typography>
							</Grid>
						);
					})}
				</Grid>
			}
			{...props.toolTipProps}
			className={props.className}
		>
			{props.children}
		</Component>
	);
};

CustomTooltip.defaultProps = {
	applyMinWidth: true,
};

interface ICustomTooltipProps {
	toolTipProps?: Partial<TooltipProps>;
	children: JSX.Element;
	items: ICustomTooltipTitleitems[];
	display?: boolean;
	className?: string;
	applyMinWidth?: boolean;
}

export interface ICustomTooltipTitleitems {
	label?: string;
	value?: string;
	header?: string;
	onRender?: () => JSX.Element;
}

export default CustomTooltip;



// WEBPACK FOOTER //
// ./src/components/shared/custom-tooltip.component.tsx